// This file defines a module that models our application instance,
// its initialization, and useful functions for performing common
// application tasks.

goog.require('el8.tourguide.tease');

goog.require('el8.appchart.layout');
goog.require('el8.appchart.navtriggers');
goog.require('el8.appchart.metrics');

goog.require('el8.appchart.refpanel.allergies');
goog.require('el8.appchart.refpanel.confidential');
goog.require('el8.appchart.refpanel.demog');
goog.require('el8.appchart.refpanel.history');
goog.require('el8.appchart.refpanel.immunizations');
goog.require('el8.appchart.refpanel.intols');
goog.require('el8.appchart.refpanel.maint');
goog.require('el8.appchart.refpanel.family');
goog.require('el8.appchart.refpanel.legal');
goog.require('el8.appchart.refpanel.problems');
goog.require('el8.appchart.refpanel.prenatalFlowsheets');
goog.require('el8.appchart.refpanel.referrals');
goog.require('el8.appchart.refpanel.tags');
goog.require('el8.appchart.refpanel.providers');

goog.require('el8.appchart.refpanel.setup');
goog.require('el8.appchart.refpanel.meds');
goog.require('el8.appchart.printService');

goog.require('el8.appchart.letters.main');
goog.require('el8.appchart.nonvisitNote.main');
goog.require('el8.appchart.visitNote.main');
goog.require('el8.appshared.feedItemActions');
goog.require('el8.appchart.unverifiedPatient');

goog.require('el8.data.base');
goog.require('el8.data.practiceUsers');

goog.require('el8.appchart.dialog.order.base');
goog.require('el8.appchart.dialog.order.lab');
goog.require('el8.appchart.dialog.order.cardiac');
goog.require('el8.appchart.dialog.order.imaging');
goog.require('el8.appchart.dialog.order.pulmonary');
goog.require('el8.appchart.dialog.order.sleep');
goog.require('el8.appchart.dialog.ordermed.prescription');
goog.require('el8.appchart.dialog.ordermed.controlled');
goog.require('el8.appchart.dialog.ordermed.otc');

goog.require('el8.appchart.mgr.notes');
goog.require('el8.appchart.mgr.orderForm');
goog.require('el8.appchart.dialog.reports');
goog.require('el8.appchart.mgr.overlay');
goog.require('el8.appchart.mgr.onHold');
goog.require('el8.appchart.mgr.taskbar');
goog.require('el8.appchart.mgr.thirdpane');

goog.require('el8.model.base');
goog.require('el8.ptdata.model.report');
goog.require('el8.ptdata.model.order');
goog.require('el8.ptdata.model.patient');
goog.require('el8.ptdata.model.message');

goog.require('el8.ptdata.base');
goog.require('el8.ptdata.historyItems');
goog.require('el8.ptdata.visitNotes');

goog.require('el8.appshared.message');
goog.require('el8.appshared.newMessage');
goog.require('el8.render.content');
goog.require('el8.util.dom');
goog.require('el8.util.feed');
goog.require('el8.util.consts');

goog.require('el8.uiwidget.base');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.Dialog');
goog.require('el8.uiwidget.collapsible');

goog.require('el8.appchart.cqmRefresh');
goog.require('el8.appchart.init.mainFeeds');
goog.require('el8.appchart.mainFeeds.chart');
goog.require('el8.appchart.mainFeeds.outstanding');
goog.require('el8.appchart.mainFeeds.plrNotification');
goog.require('el8.appchart.mainFeeds.reqAct');
goog.require('el8.appchart.reportFeeds.feeds');
goog.require('el8.appchart.reportFeeds.main');

goog.require('el8.appshared.dialog.editPatient');
goog.require('el8.appchart.dialog.addEditProblem');
goog.require('el8.appchart.dialog.addEditAmendmentRequest');
goog.require('el8.appshared.dialog.viewEducationalHandouts');
goog.require('el8.appchart.medsHx.displaySummary');

goog.require('el8.app.setup');
goog.require('el8.ptdata.init');
goog.require('el8.practicedata.appts');
goog.require('el8.practicedata.immunizationRegistries');
goog.require('el8.service.urls');
goog.require('el8.tourguide.onboardChart');
goog.require('el8.appservice.notifier');

goog.require('el8.app.shared.dialog.enterpriseImportPatientFTUX');

var el8 = el8 || {};
if(!el8.main) { el8.main = {}; }
el8.main.appchart = {};

function queryParamDataInit (queryParamData) {
    for (var key in queryParamData) {
        if (queryParamData.hasOwnProperty(key) && queryParamData[key]) {
            switch(key) {
                case 'appointment':
                    el8.practicedata.appts.create(queryParamData[key]);
                default:
                   break;
            }
        }
    }
}

el8.main.appchart.init = function(spec) {
    // Keep this at the top because one or more of the legacy functions below will
    // mutate `spec` and in some cases make nonsense changes to it
    el8React.configureStore(spec);

    spec['layout'] = {innerContainerSelector: '#refBoard'};
    el8.app.setup(spec);

    el8.ptdata.init(spec['ptdata']);

    queryParamDataInit(spec['queryParamData']);

    var location = Object.assign({}, window.location);
    if (location.pathname === el8Globals['PATIENT_PATH'] + 'vnote/') {
        window.history.replaceState({
            search: location.search
        }, document.title, el8Globals['PATIENT_PATH'] + location.search);
    }

    el8React.render.dialogs('react-dialogs-container');
    el8React.render.approvePrescriptionChangeDialog('react-approve-prescription-change-dialog');
    el8React.render.approvePrescriptionChangeWithModificationsDialog(
      'react-approve-prescription-change-with-modifications-dialog'
    );
    el8React.render.contactDialog('react-contact-form-dialog');
    el8React.render.denyPrescriptionChangeDialog('react-deny-prescription-change-dialog');
    el8React.render.cancelPrescriptionDialog('react-cancel-prescription-form-target');
    el8React.render.immunizationHistoryForecastController('react-immunization-history-forecast-controller');
    el8React.render.insuranceDialog('insurance-dialog-container');
    el8React.render.outsideCareController('react-outside-care-controller');
    el8React.render.prescriptionFormDialog2('react-prescription-form-target');
    el8React.render.prescriptionTemplateDialog('react-prescription-template-dialog');
    el8React.render.prescriptionPriorAuthObtainedDialog('react-prescription-prior-auth-obtained-dialog')
    el8React.render.prescriptionPriorAuthPayerDeniedDialog('react-prescription-prior-auth-payer-denied-dialog');
    el8React.render.prescriptionPriorAuthPayerNotContactedDialog('react-prescription-prior-auth-payer-not-contacted-dialog');
    el8React.render.specimenCollectionController('react-specimen-collection-controller');

    // clinical profile React
    el8React.render.exerciseHistoryStructuredSection('react-exercise-history-structured-section');
    el8React.render.habitsHistoryStructuredSection('react-habits-history-structured-section');
    el8React.render.patientProfile('react-patient-profile');
    el8React.render.patientProfileInfoGrid('react-patient-profile-info-grid');
    el8React.render.psychologicalHistoryStructuredSection('react-psychological-history-structured-section');
    el8React.render.socialHistoryStructuredSection('react-social-history-structured-section');
    el8React.render.functionalHistoryStructuredSection('react-functional-history-structured-section');
    el8React.render.cognitiveStructuredSection('react-cognitive-structured-section');

    el8React.render.findChartHeaderButton('react-chartnav');

    el8React.render.websocketListener('react-websocket-listener');

    if (el8Globals.FEATURES.IntegratedScribe) {
        /**
         * Handler for Nabla Copilot extension export to Elation Visit Note (VN1, VN2)
         * This function is debounced to try and avoid multiple duplicate exports into the EHR.
         */
        var handleNablaCopilotEventExportToVisitNote = _.debounce(function (event) {
            // FUTURE: Notify Nabla extension that export content was received and processing?

            // Apply export to currently opened VN2 draft
            if (el8.appchart.mgr.thirdpane.isVisitNote2Open()) {
                el8React.messenger.send('NablaCopilotExportSummary', {
                    type: 'NablaCopilotExportSummary',
                    payload: event.data
                });
                return;
            }

            // Apply export to currently opened (or prompt to open) VN1 draft
            el8.appchart.mgr.notes.applyNablaCopilotDraftContent(event.data);
        }, 3000, {leading: true, trailing: false});

        /**
         * Handle event from the Nabla Copilot extension (currently, only export to VN1 or VN2)
         */
        function handleNablaCopilotEvent(event) {
            console.log("[aiscribe] Received message from integrated scribe", event.data);

            if (event.data.nablaCopilot.note) {
                handleNablaCopilotEventExportToVisitNote(event);
                return;
            }

            // Forward any unsupported Nabla Copilot events to Sentry for debugging
            var errorMessage = "[aiscribe] Unexpected message received from integrated scribe: " +
                Object.keys(event.data.nablaCopilot).join(', ');
            if (UIM) {
                UIM.logError(errorMessage);
            } else {
                console.error(errorMessage);
            }
        }

        /**
         * Check if event is from the Nabla Copilot extension
         */
        function isNablaCopilotEvent(event) {
            return typeof event.data === 'object' &&
                typeof event.data.nablaCopilot === 'object' &&
                event.origin === window.location.origin;
        }

        // Listen for export events from the Nabla extension
        window.addEventListener("message", function (event) {
            if (!event.data) {
                return;
            }
            if (isNablaCopilotEvent(event)) {
                handleNablaCopilotEvent(event);
                return;
            }
        });

        // Send Nabla extension IntegratedScribe feature status (handshake)
        console.log("[aiscribe] Sending config to integrated scribe");
        window.postMessage({
            elationConfig: {
               isExportEnabled: el8Globals.FEATURES.IntegratedScribe
            }
        });
    }

    if (spec.ack.message) {
        // Ack mesage is replaced by the standard timezone message, so we wan to show it with delay
        console.log(spec.ack.message)
        window.setTimeout(function() {
          el8.appservice.notifier.notify(spec.ack.message);
        }, 200);
    }


    /**
     * Load metadata we will find useful
     */
     var data = {};

     if (el8Globals['DISPLAY_VISIT_NOTE']) {
         _(data).extend(
             {
                 'with_visit_note': 1,
                 'appointment_id': el8.util.getUrlParam('appointment_id')
             }
         );
     }

     $.el8_ajax({
       url: el8Globals.PATIENT_PATH + 'accessed',
       type: 'POST',
       async: true
       // no callbacks, we don't care what happens to this call
     });

    $.el8_ajax({
        url: el8.service.urls.get('practiceDetails'),
        async: false,
        data: data,
        success: function(data) {
            if (data['next_appt']) {
                el8.ptdata.ptNextAppt.populate(data['next_appt']);
            }
            // this is actually the last visit note time
            el8.appchart.refpanel.setupLastAppt(data['last_appt_time']);
            if (data['pt_registration_info']) {
                el8.ptdata.ptRegistrationInfo.populate(data['pt_registration_info']);
            }

            el8Globals['DISPLAY_VISIT_NOTE'] = data['visit_note'];
            // confusing name: nothing to do with "display" it seems, but rather the type for create
            el8Globals['DISPLAY_VISIT_NOTE_TEMPLATE'] = data['visit_note_template'] || '';

            el8Globals['DISPLAY_VISIT_NOTE_TYPE_ID'] = data['visit_note_type_id'] || '';

        }
    });
    // TODO: these loads are all synchronous and that's bad.
    // If they really need to stay synchronous, we should make one request that
    // can return all this data at once. Otherwise, we should make them async.
    el8.data.practiceUsers.load();
    el8.data.staffGroups.load();
    el8.data.noteSettings.load();
    el8.data.reportNoteTemplates.load();
    el8.data.premadeMessages.load();
    el8.data.visitNoteTypes.load();
    el8.data.nonvisitNoteTypes.load();

    // Load Immunization Registries configured for the current practice
    el8.practicedata.immunizationRegistries.load();

    /**
     * Initial feeds load
     */
    el8.appchart.layout.setup();
    el8.appchart.init.mainFeeds();

    // If the notes mgr directly requires these files, it creates a circular
    // dependency (a true one... the files are circularly dependent).
    // So we pass in references here, before el8.appchart.mgr.notes.showVisitNote
    // can be called.
    el8.appchart.mgr.notes.init({
        visitNote: el8.appchart.visitNote.main,
        nonvisitNote: el8.appchart.nonvisitNote.main
    });

    $('#chart-feed-contents').addClass('feedLoading');

    var reportOnFirstLoad = el8.appchart.metrics.getChartLoadCallback('initial-feeds');
    $.el8_ajax({
        url: el8Globals['PATIENT_PATH']+'initial-feeds/',
        data: {
            chart_limit: el8.util.consts.CHART_FEED_PAGESIZE
        },
        success: function(data) {
            if (el8Globals['TEASE']) { el8.tourguide.tease.init(); }
            else if (el8Globals['ONBOARDING']) { el8.tourguide.onboardChart.init(); }

            $('#chart-feed-contents').removeClass('feedLoading');

            el8React.render.chartFeedQuickActionsBar('react-chart-feed-quick-actions-container');

            el8React.render.pmpOverdoseRiskScore('react-pmp-overdose-risk-score-container');

            var indexes = data['indexes'];
            var items = data['items'];
            el8.ptdata.ptload(items);

            // load both of these indexes before displaying either, because rendering either can
            // trigger mainFeeds.js/updateReqActContainer, which will check the indexes' lengths
            el8.appchart.mainFeeds.reqAct.loadIndex(indexes['unsigned']['requiring_action']);
            el8.appchart.mainFeeds.outstanding.loadIndex(indexes['unsigned']['outstanding']);

            el8.appchart.mainFeeds.reqAct.display();
            el8.appchart.mainFeeds.outstanding.display();

            // Do chart feed last cuz it's the slowest
            el8.appchart.mainFeeds.chart.loadIndex(indexes['chart_feed']);
            el8.appchart.mainFeeds.chart.display();

            // Finally, do report feeds
            var reportTypeIds = indexes['report_feeds']['sequence'];
            el8.appchart.reportFeeds.main.init(reportTypeIds);

            for (var i=0; i < reportTypeIds.length; i++) {
                var rTypeId = reportTypeIds[i];
                var index = indexes['report_feeds'][reportTypeIds[i]];
                el8.appchart.reportFeeds.main.loadReportIndex(rTypeId, index);
            }

            // Make the reqact/outstanding sections collapsible, once they've been rendered
            el8.uiwidget.collapsible({
                container: $('#reqAct-feed-list'),
                triggerElt: $('#reqact-collapse-trigger'),
                statusElt: $('#reqact-collapse-status')
            });
            el8.uiwidget.collapsible({
                container: $('#outstanding-feed-list'),
                triggerElt: $('#outstanding-collapse-trigger'),
                statusElt: $('#outstanding-collapse-status')
            });

            if (!el8Globals['TEASE']) {
                // Do the special "initial load" stuff

                if (el8Globals['DISPLAY_VISIT_NOTE']) {
                    // Note that this global is set through the practiceDetails fetch
                    // It's called here because showVisitNote() needs the feed to be loaded
                    el8.appchart.mgr.notes.showVisitNote({
                        schedulerAutoOpen: true,
                        templateType: el8Globals['VISIT_NOTE_TEMPLATE'] || el8Globals['DISPLAY_VISIT_NOTE_TEMPLATE'],
                        visitNoteTypeId: el8Globals['VISIT_NOTE_TYPE_ID'] || el8Globals['DISPLAY_VISIT_NOTE_TYPE_ID']
                    });
                }
                if (el8Globals['REQ_ACTION']) {
                    // If there is an unread report, then launch report feed overlay
                    var firstUnreadReport = el8.appchart.mainFeeds.reqAct.getFirstUnreadReport();
                    if( firstUnreadReport ) {
                        el8.appchart.dialog.reports.show({ item: firstUnreadReport });
                    }
                }

                if (el8.util.getUrlParam('demog')) {
                    el8.appshared.dialog.editPatient.show();
                }

                var lhs_imported = el8.util.getUrlParam('lhs_imported');
                if (lhs_imported !== '') {
                    var lhs_int = parseInt(lhs_imported, 10);
                    if (lhs_int === 1) {
                        el8.app.shared.dialog.enterpriseImportPatientFTUX.show({
                            lhsImported: 1
                        });
                    } else if (lhs_int === 0) {
                        el8.appchart.refpanel.compareRefpanel.show({FTUX: true});
                    }
                }

                var visitNoteId = el8.util.getUrlParam('visit_note_id');
                if (visitNoteId) {
                    var note = el8.ptdata.visitNotes.getById(visitNoteId);
                    if (note && !note.isSignedOff()) {
                        // for unsigned notes, open in draft
                        el8.appchart.mgr.notes.showVisitNote({ note: note});
                    }
                    else {
                        // navigate chart feed to signed note, if the feed recognizes it
                        el8.appchart.mainFeeds.chart.showItem(visitNoteId);
                    }
                }
            }

            // fetch the first page of reports for each report feed so that they're
            // cached when the user opens the reports dialog. If REQ_ACTION is true,
            // we already synchronously fetched the page we needed for that
            _.defer(function() {
                var reportIdsToCache = [];
                for (var i=0; i < reportTypeIds.length; i++) {
                    var ids = _.pluck(indexes['report_feeds'][reportTypeIds[i]], 'id');
                    ids = ids.slice(0, el8.util.consts.REPORT_FEED_PAGESIZE);
                    reportIdsToCache = reportIdsToCache.concat(ids);
                }
                el8.ptdata.fetch({ // checks the existing cache before truly fetching
                    async: true,
                    fetchIds: reportIdsToCache
                });
            });

            // Also cache the first visit note in the chart (if one exists).
            // This is used by the active problem list, which will want
            // to look at the last signed visit for any acute DXs
            _.defer(function() {
                var visitIndexItem = _.find(indexes['chart_feed'], function(indexItem) {
                    return indexItem.model_class === 'VisitNote' &&
                           indexItem.document_sub_type === null;
                });
                if (visitIndexItem) {
                    el8.ptdata.fetch({
                        async: true,
                        fetchId: visitIndexItem.id
                    });
                }
            });

            reportOnFirstLoad();

            // if we have PLR collaborators, and has feature flag on, we run the PLR search by default
            if (el8Globals.FEATURES.PLRAutoShowSharedDoc && el8.ptdata.plrCollaborators.all().length) {
                setTimeout(function() {
                    var isInitialLoad = true;
                    el8.appchart.mainFeeds.chart.doCareteamSearch(isInitialLoad);
                }, 20);
            }
        }
    });

    /**
     * Refpanel Setup
     *
     * Note: if you add a new section here with an AJAX load, make sure to get a new callback from
     * el8.appchart.metrics.getChartLoadCallback() and call it when the AJAX load completes.
     */
    if (!el8Globals['TEASE']) {
        el8.appchart.navtriggers.setup();
    } else {
        $('a, button', $('#chart-write-see-bar')).unbind('click').on('click', function(e) {
            if ($(this).hasClass('meds_history_trigger')) {
                el8.appchart.medsHx.main.show();
            } else if ($(this).hasClass('report_feed_trigger')) {
                el8.appchart.dialog.reports.show();
            } else {
                $(document).trigger('show-learn-more');
            }
            return false;
        });
    }

    el8.appchart.refpanel.setup();
    el8.appchart.refpanel.demog.show();
    el8.appchart.refpanel.tags.show();

    el8.appchart.refpanel.allergies.show(true);
    el8.appchart.refpanel.intols.show(true);

    el8.appchart.refpanel.maint.show(true);

    el8.appchart.refpanel.problems.show(true);
    el8.appchart.refpanel.prenatalFlowsheets.show(true);
    el8.appchart.refpanel.history.show(true);
    el8.appchart.refpanel.legal.show(true);
    el8.appchart.refpanel.family.show(true);

    if (!el8Globals.FEATURES.ProvidersNetwork) {
        el8.appchart.refpanel.referrals.show(true);
    }
    else {
        el8.appchart.metrics.skipChartSection('referrals');
    }

    el8.appchart.refpanel.immunizations.show(true);
    el8.appchart.refpanel.confidential.show(true);

    el8.appchart.refpanel.meds.show(true);
    if (el8Globals.FEATURES.ProvidersNetwork) {
        el8.appchart.refpanel.providers.show(true);
    }
    else {
        el8.appchart.metrics.skipChartSection('providers');
    }

    if (!el8Globals['FEATURES']['ERx']) { // Remove these buttons if eRx is off
        $('.eligibilities_trigger').hide();
    }

    /**
     * Initialize misc other pieces of the chart
     */

    el8.appchart.unverifiedPatient.init();

    // Initialize the Form Managers, etc.
    el8.appchart.mgr.taskbar.init();
    el8.appshared.message.init(el8.appshared.newMessage);
    el8.appchart.mgr.orderForm.init({
        onHoldMgr: el8.appchart.mgr.onHold,
        orderForms: {
          lab : el8.appchart.dialog.order.lab,
          imaging : el8.appchart.dialog.order.imaging,
          cardiac : el8.appchart.dialog.order.cardiac,
          sleep : el8.appchart.dialog.order.sleep,
          pulmonary : el8.appchart.dialog.order.pulmonary,
          prescription : el8.appchart.dialog.ordermed.prescription,
          otc: el8.appchart.dialog.ordermed.otc,
          controlled: el8.appchart.dialog.ordermed.controlled
        },
        navtriggers: el8.appchart.navtriggers
    });
    el8.appchart.medsHx.displaySummary();

    el8.appchart.mainFeeds.plrNotification.init();

    // Load EPCS status eagerly
    el8.data.currUser.loadEpcsStatus(true);

    el8.appchart.cqmRefresh.init();

    el8.appchart.visitNote.vitalFields.initCustomFieldMap();
};
